import { render } from "./About.vue?vue&type=template&id=a1b83716"
const script = {}
script.render = render

export default script